import { Card } from '@fl/cmsch-fe-library';
import React, { FC, memo } from 'react';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { Ant } from 'common/ant';
import { ConnectedScreenHeader } from 'common/layout';
import { ManagementAssociationsTable } from '../components/management-associations-table';
import { ManagementBreedersTable } from '../components/management-breeders-table/table';
import { ManagementOrganizationTable } from '../components/management-organization-table';
import { ManagementOtherSubjectTable } from '../components/management-other-subjects-table';
const BreederManagementBase: FC = _ => {
  const {
    t
  } = useOurTranslation('admin');
  return <Content browserTabTitle={t('breederManagementScreenTitle')} data-sentry-element="Content" data-sentry-component="BreederManagementBase" data-sentry-source-file="breeder-management.tsx">
            <Card testId="screenTitle" title={<ConnectedScreenHeader title={t('breederManagementScreenTitle')} moduleForTutorials="SUBJECT_USER_ADMINISTRATION" />} titleSize="medium" data-sentry-element="Card" data-sentry-source-file="breeder-management.tsx">
                <Ant.Tabs type="card" data-sentry-element="unknown" data-sentry-source-file="breeder-management.tsx">
                    <Ant.Tabs.TabPane key="breeders" tab={t('breeders')} data-sentry-element="unknown" data-sentry-source-file="breeder-management.tsx">
                        <ManagementBreedersTable data-sentry-element="ManagementBreedersTable" data-sentry-source-file="breeder-management.tsx" />
                    </Ant.Tabs.TabPane>
                    <Ant.Tabs.TabPane key="associations" tab={t('associations')} data-sentry-element="unknown" data-sentry-source-file="breeder-management.tsx">
                        <ManagementAssociationsTable data-sentry-element="ManagementAssociationsTable" data-sentry-source-file="breeder-management.tsx" />
                    </Ant.Tabs.TabPane>
                    <Ant.Tabs.TabPane key="authorizedOrganizations" tab={t('authorizedOrganizations')} data-sentry-element="unknown" data-sentry-source-file="breeder-management.tsx">
                        <ManagementOrganizationTable data-sentry-element="ManagementOrganizationTable" data-sentry-source-file="breeder-management.tsx" />
                    </Ant.Tabs.TabPane>
                    <Ant.Tabs.TabPane key="otherSubjects" tab={t('otherSubjects')} data-sentry-element="unknown" data-sentry-source-file="breeder-management.tsx">
                        <ManagementOtherSubjectTable data-sentry-element="ManagementOtherSubjectTable" data-sentry-source-file="breeder-management.tsx" />
                    </Ant.Tabs.TabPane>
                </Ant.Tabs>
            </Card>
        </Content>;
};

/** Admin breeder management screen. */
export const BreederManagement = memo(BreederManagementBase);